<template>
  <v-container>
    <h2>Levels</h2>
    <app-base
      ref="crud"
      :source="getLevels"
      :post="postLevels"
      :tableHeader="headers"
      @edit="onEdit"
      @remove="onRemove"
    >
      <template v-slot:title>Create Level</template>
      <template v-slot:form>
        <v-text-field
          id="name"
          v-model="name"
          dense
          label="Name"
          outlined
          :rules="[(v) => !!v || 'Name required']"
        />
      </template>
    </app-base>
    <app-confirm-dialog v-model="removeDialog" @yes="onYes" :loading="removeLoading" />
    <app-edit-name v-model="editDialog" :item="editedItem" :patch="patch" @itemUpdated="onUpdate" />
  </v-container>
</template>
<script>
/* eslint-disable no-console */
import Base from "./Base.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import EditName from "./EditName.vue";
import { postLevels, getLevels, removeLevel, patchLevel } from "@/api/api";
import removeMixin from "@/mixins/removeMixin";
import editNameMixin from "@/mixins/editNameMixin";

export default {
  components: {
    appBase: Base,
    appConfirmDialog: ConfirmDialog,
    appEditName: EditName,
  },
  mixins: [removeMixin, editNameMixin],
  data() {
    return {
      name: "",
      getLevels,
      postLevels,
      headers: [
        { text: "Level", value: "name", align: "left" },
        { text: "Created", value: "created_at", align: "right" },
        { text: "", value: "button", align: "right" },
        { text: "Remove", value: "remove", align: "center" },
      ],
      remover: removeLevel,
      patch: patchLevel,
    };
  },
};
</script>
